export const validationPatterns = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  mobile: /^[0-9]{10}$/,
  AZ: /[A-Z]/,
  az: /[a-z]/,
  number: /[0-9]/,
  anyChar: /[^A-Za-z0-9]/,
  alphabet: /^[a-zA-Z\s]*$/,
  decimalPattern: /^\d+(\.\d+)?$/,
  specialChar: /[!@#$%^&*(),.?":{}|<>]/g,
};

export const validTLDs = [".com", ".org", ".net", ".in"];

class InputValidator {
  static isValidLoginEmail(input) {
    input = input.trim();
    const emailRegex = /^[^\s@]+@nucleusteq\.com$/;
    if (input === "") {
      return "Email should not be empty.";
    } else if (!emailRegex.test(input)) {
      return "Invalid email format.";
    } else {
      return "";
    }
  }

  static isValidPassword(input) {
    input = input.trim();
    if (input === "") {
      return "Password should not be empty.";
    } else if (input.length < 8) {
      return 'Password should have atleast 8 characters.'
    } else {
      return "";
    }
  }

}

export default InputValidator;